function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(0 0)"
}, React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M11.688,18.633a2.659,2.659,0,0,0-1.956.8,2.627,2.627,0,0,0-.8,1.928V32.883a2.743,2.743,0,0,0,2.759,2.759,2.618,2.618,0,0,0,1.942-.8,2.681,2.681,0,0,0,.79-1.956V21.365a2.743,2.743,0,0,0-2.732-2.732Z",
  transform: "translate(-8.929 -4.195)",
  fill: "#a4c53a"
}), React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M33.06,10.1l1.9-3.509a.354.354,0,0,0-.134-.536.372.372,0,0,0-.536.161L32.364,9.751a13.439,13.439,0,0,0-10.768,0L19.667,6.215a.372.372,0,0,0-.536-.161A.352.352,0,0,0,19,6.59L20.9,10.1a11.743,11.743,0,0,0-4.607,4.112,10.384,10.384,0,0,0-1.714,5.773H39.355a10.4,10.4,0,0,0-1.714-5.773A11.8,11.8,0,0,0,33.06,10.1Zm-11,5.1a1.006,1.006,0,0,1-.737.309A.962.962,0,0,1,20.6,15.2a1.07,1.07,0,0,1,0-1.473.965.965,0,0,1,.723-.307,1.041,1.041,0,0,1,.737,1.781Zm11.29,0a.961.961,0,0,1-.722.309,1.045,1.045,0,0,1,0-2.089.962.962,0,0,1,.722.307,1.067,1.067,0,0,1,0,1.473Z",
  transform: "translate(-8.122 -6)",
  fill: "#a4c53a"
}), React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M14.671,36.918a2.925,2.925,0,0,0,2.945,2.946H19.6l.027,6.081a2.661,2.661,0,0,0,.8,1.956,2.627,2.627,0,0,0,1.928.8,2.743,2.743,0,0,0,2.759-2.759V39.864h3.7v6.081a2.759,2.759,0,1,0,5.518,0V39.864h2.009a2.925,2.925,0,0,0,2.919-2.945V19.078H14.671Z",
  transform: "translate(-8.108 -4.131)",
  fill: "#a4c53a"
}), React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M39.856,18.633a2.656,2.656,0,0,0-1.928.79,2.619,2.619,0,0,0-.8,1.942V32.883a2.657,2.657,0,0,0,.8,1.956,2.629,2.629,0,0,0,1.928.8,2.743,2.743,0,0,0,2.759-2.759V21.365a2.619,2.619,0,0,0-.8-1.942A2.689,2.689,0,0,0,39.856,18.633Z",
  transform: "translate(-4.9 -4.195)",
  fill: "#a4c53a"
}));

var SvgAndroid = function SvgAndroid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    width: 37.715,
    height: 44.573,
    viewBox: "0 0 37.715 44.573",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAndroid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Android.4d3cdec3.svg";
export { ForwardRef as ReactComponent };